import React from "react";
import { Grid } from "material-ui";
import { Row } from 'react-flexbox-grid';
import { Card } from "@material-ui/core";
import { CardHeader } from "material-ui";
import { CardContent } from "material-ui";
import Typography from '@material-ui/core/Typography';
import { assets } from "../../../assets/";
import { AverageDistanceText } from "./AverageDistanceText";

export class AverageDistanceCard extends React.Component {

  render() {
    const { 
      classes, 
      t, 
      averageDistanceInMetersForRange,
      averageDistanceInMetersYTD,
      loading,
      dateRangeText,
      user
    } = this.props;

    return (
      <Grid item xs={12} sm={3}>
        <Card className={classes.card} style={{ minHeight: 224 }}>
          <CardHeader
            avatar={<img src={assets.icons.routeIcon} alt="route_icon" style={{ maxHeight: 20 }} />}
            title={t("Average distance")}
          />
          <CardContent>
            <Grid container spacing={24}>
              <Grid item>
                <Row>
                  <Typography
                    className={classes.title}
                    variant="caption"
                    gutterBottom
                    color="textSecondary"
                  >
                    {dateRangeText}
                  </Typography>
                </Row>
                <Row>
                  <AverageDistanceText t={t} classes={classes} loading={loading}
                    averageDistance={averageDistanceInMetersForRange}
                    user={user}
                  />
                </Row>
                <Row style={{marginTop: 8}}>
                  <Typography
                    className={classes.title}
                    variant="caption"
                    gutterBottom
                    color="textSecondary"
                  >
                    {t("Yearly")}
                  </Typography>
                </Row>
                <Row>
                  <AverageDistanceText t={t} classes={classes} loading={loading}
                    averageDistance={averageDistanceInMetersYTD}
                    user={user}
                  />
                </Row>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/EquivalentToCards/AverageDistance/AverageDistanceCard.js